import { createFileRoute } from '@tanstack/react-router';
import { FazendaDetailView } from '@/modules/agronomia/components/FazendaDetailView';

// Tela 03 · Fazenda (detalhe) — mapa, clima, talhões.
export const Route = createFileRoute('/_authed/agronomia_/fazendas_/$id')({
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <FazendaDetailView imovelId={Number(id)} />;
}
